/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * MediaCenter
 * @export
 * @interface MediaCenter
 */
export interface MediaCenter {
    /**
     * Title of the media center.
     * @type {string}
     * @memberof MediaCenter
     */
    title?: string;
    /**
     * Description of the media center.
     * @type {string}
     * @memberof MediaCenter
     */
    description?: string;
}

export function MediaCenterFromJSON(json: any): MediaCenter {
    return MediaCenterFromJSONTyped(json, false);
}

export function MediaCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaCenter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function MediaCenterToJSON(value?: MediaCenter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'description': value.description,
    };
}

